import __json from '../config/countryStateCodes.json';

type DataFromJson = Readonly<Record<string, { stateCodes: readonly string[] }>>;

export const countryStateCodes: DataFromJson = __json;
